// extracted by mini-css-extract-plugin
export default {"accessDeniedContainer":"AccessDenied_accessDeniedContainer__FxXHZ"};